import { useSelectContext } from "@molecules/Select/Select.context"

import { SelectFetchingNextPageProps } from "./SelectFetchingNextPage.types"

export default function SelectFetchingNextPage(props: SelectFetchingNextPageProps) {
    const { children } = props
    const { searchData } = useSelectContext()

    if (!searchData?.isFetchingNextPage) {
        return null
    } else {
        return <>{children}</>
    }
}
